import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { editCurrency, getCurrency } from "../../Redux/Actions/currencyActions";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { columnsCurrencyList } from "../../Global Functions/columnsAntd";
import TableComponent from "../../Global Functions/tableComponents";
import toast from "react-hot-toast";
import CountryEditModal from "./addCurrency";
import { Button } from "antd";

const ListCurrency = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const fetchDetails = useCallback(
    (showLoader) => {
      return dispatch(getCurrency(showLoader)).catch(() => {
        if (!showLoader) {
          toast.error("Failed to refresh Currency history list");
        }
      });
    },
    [dispatch]
  );


  // Get currency data from Redux
  const currencyState = useSelector((state) => state.currency || {});
  const countries = useMemo(() => {
    return currencyState.currencyData?.countries || [];
  }, [currencyState.currencyData]);
  const { loading } = useSelector((state) => state.currency);

  useEffect(() => {
    dispatch(getEnums());
  }, [dispatch]);

  const enumsData = useSelector((state) => state.enumsData);

  useEffect(() => {
    fetchDetails();
  }, [fetchDetails]);

  useEffect(() => {
    setPagination((prev) => ({ ...prev, total: countries.length }));
  }, [countries]);

  const openEditModal = (country = null) => {
    setSelectedCountry(country);
    setIsModalOpen(true);
  };

  const closeEditModal = () => {
    setSelectedCountry(null);
    setIsModalOpen(false);
  };

  const handleSubmit = async (values) => {
    const prevCountries = currencyState.currencyData?.countries || [];

    // Check if currency code already exists (excluding currently edited country)
    const isDuplicateCurrency = prevCountries.some(
      (country) =>
        country.currency === values.currency &&
        country._id !== selectedCountry?._id
    );

    if (isDuplicateCurrency) {
      toast.error("Currency already exists");
      return { success: false };
    }

    // Proceed with rest of logic for add/edit...
    const countryIndex = prevCountries.findIndex(
      (country) => country._id === selectedCountry?._id
    );

    let updatedCountries;
    if (countryIndex !== -1) {
      updatedCountries = [
        ...prevCountries.slice(0, countryIndex),
        { ...prevCountries[countryIndex], ...values },
        ...prevCountries.slice(countryIndex + 1),
      ];
    } else {
      updatedCountries = [...prevCountries, values];
    }

    const payload = {
      countries: updatedCountries,
      setting_id: currencyState?.currencyData?._id || "",
    };

    const result = await dispatch(editCurrency(payload));
    if (result.success) {
      toast.success("Currency saved successfully");
      fetchDetails(false);
      closeEditModal();
    } else {
      toast.error("Failed to save currency");
    }
    return result;
  };


  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleFilter = () => {
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  return (
    <>
      <div style={{ position: "absolute", marginTop: "9.6%", marginLeft: "86.5%" }}>
        {( canAdd && 
        <Button
        style={{ background: "#0D1A52", color: "white", padding: "18px" }}
        onClick={() => openEditModal(null)}
        >
          Add Currency
        </Button>
        )}
      </div>

      <TableComponent
        pagination={pagination}
        filterFunction={handleFilter}
        dataSource={countries}
        onChange={handleTableChange}
        h3heading="Currency List"
        columns={columnsCurrencyList(canEdit)}
        loading={loading}
      />

      {isModalOpen && (
        <CountryEditModal
          visible={isModalOpen}
          countryData={selectedCountry}
          onSave={handleSubmit}
          onClose={closeEditModal}
          enumsData={enumsData}
        />
      )}
    </>
  );
};

export default ListCurrency;
